exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-hidden[data-v-9b2003de] {\n  display: none;\n}\n.disable[data-v-9b2003de] {\n  color: white !important;\n  background-color: #CCCCCC !important;\n  cursor: inherit;\n}\n.planSelectDescBoxTitle[data-v-9b2003de] {\n  color: #202020;\n}", ""]);

// exports
